export const optionalBetUrl = ({ orderId }) => `/optional-bet/${orderId}`;
